import Vue from 'vue';

// initial state
const state = {
  allProducts: [],
  product: null,
  packagesProduct: [],
  queryParams: {
    fundid: null
  }
}


// getters
const getters = {
  allProducts: state => state.allProducts,
  product: state => state.product,
  packagesProduct: state => state.packagesProduct
}

// mutations
const mutations = {
  setProducts(state, products) {
    state.allProducts = products
  },
  setProduct(state, product) {
    console.log("setProduct", product)
    state.product = product
  },
  setPackagesProduct(state, packages) {
    state.packagesProduct = packages
  },
  setProductQueryParam(state, { field, value }) {
    state.queryParams[field] = value
  }
}

// actions
const actions = {
  getAllProducts: function ({ commit }) {
    Vue.http.get(wwfconfigs.CLOUDFUNCTION + '/' + 'getProducts').then(response => {
      commit('setProducts', response.body);
    });
  },
  getProductById: function ({ commit }, data) {
    console.log('getProductById');
    return new Promise((resolve, reject) => {
      console.log(wwfconfigs.CLOUDFUNCTION + '/' + 'getProductsbyId?productId=' + data.id);
      Vue.http.get(wwfconfigs.CLOUDFUNCTION + '/' + 'getProductsbyId?productId=' + data.id).then(response => {
        console.log(response);
        let product = response.body
        product.id = data.id;
        product.source = data.source;

        // Map the old structure to the new one
        // Need to populate the donationsettings object
        if (product) {

          const keys = product.donationsettings ? Object.keys(product.donationsettings) : [];

          // Only map to the new structure if the structure is empty
          if (keys.length === 0) {
            product.donationsettings = {};

            if (product.donationtypes.length > 0) {
              for (const type of product.donationtypes) {
                product.donationsettings[type] = {
                  campaignid: product.appealcodesetting.campaignid,
                  fundid: product.appealcodesetting.fundid
                };
              }

              // Set the defaultdonationtype as the first of the array
              // Always take the first one in alphabetical order
              // In FormProduct, the default donation type is the first of this array. Just following the same structure.
              const defualtType = product.donationtypes[0];
              product.appealcodesetting.defaultdonationtype = defualtType;
              product.appealcodesetting.campaignid = product.donationsettings[defualtType].campaignid;
              product.appealcodesetting.fundid = product.donationsettings[defualtType].fundid;
            }
          }
        }

        // Override appealid and fundid
        // Suspected use only with Paypal after payment
        if (data.appealid) {
          product.appealcodesetting.appealid = data.appealid;
        }

        if (data.fundid) {
          commit('setProductQueryParam', { field: "fundid", value: data.fundid });
        }

        commit('setProduct', product);
        resolve();

      }, function (error) {
        console.log("getProductById error", error)
        reject(error)
      })
    })
  },
  getProductByIds: function ({ dispatch }, ids, rootState) {
    var products = [];
    return new Promise((resolve, reject) => {
      if (ids) {
        var promises = [];
        for (var i = 0; i < ids.length; ++i) {
          promises.push(dispatch('getOriginalProductById', ids[i]));
        }

        Promise.all(promises).then(
          response => {
            resolve(response);
          },
          error => {
            console.error("getProductById error", error);
          }
        );

      }
    })
  },
  getOriginalProductById: function ({ }, id) {
    return new Promise((resolve, reject) => {
      Vue.http.get(wwfconfigs.CLOUDFUNCTION + '/' + 'getProductsbyId?productId=' + id).then(response => {
        console.log(response);
        let product = response.body
        product.id = id;
        resolve(product);

      }, function (error) {
        console.log("getOriginalProductById error", error)
        reject(error)
      })
    })
  },
  getAllPackagesForProduct: async function ({ dispatch, state, commit }) {
    var packages = [];

    //todo refactor
    async function asyncForEach(array, callback) {
      for (let index = 0; index < array.length; index++) {
        await callback(array[index], index, array)
      }
    }

    const start = async () => {
      await asyncForEach(state.product.packages, async (id) => {
        dispatch('getPackagesById', id).then(function (value) {
          packages.push(value)
        });
      })
      commit('setPackagesProduct', packages);
    }

    if (state.product.packages && state.product.packages.length > 0) {
      return start()
    }
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}


// WEBPACK FOOTER //
// ./src/store/modules/products.js